module.exports = __webpack_public_path__ + "static/media/double-chevron-right.f7cbfb36.svg";